"use strict";
var decorators_1 = require("../util/decorators");
var metadata_1 = require("./metadata");
exports.Pipe = decorators_1.makeDecorator(metadata_1.PipeMetadata);
//# sourceMappingURL=decorators.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/src/core/pipes/decorators.js
// module id = 516
// module chunks = 6